import { Meteor } from 'meteor/meteor'
import { dispatch } from '../store'
import { SET_SETTINGS } from '../reducers/settings'

export const fetchSettings = async () => {
  const settings = await Meteor.promise('getSettings')

  dispatch({
    type: SET_SETTINGS,
    payload: settings.reduce((obj, item) => {
      obj[item.name] = item.active
      return obj
    }, {}),
  })
}
